$(window).load(function () {
  
  
  //show plus minus icon 
  if( $(".js-qty__adjust--minus").length ) {
  
    $(".js-qty__adjust--minus .icon-minus" ).attr("class", "fa fa-angle-left");
    $(".js-qty__adjust--plus .icon-plus" ).attr("class", "fa fa-angle-right");
  }
  
  $(".site-nav--has-dropdown").click(function () { 
  	
    if($(this).hasClass("active-d")) {
    	$(this).removeClass("active-d")
    } else {
    	$(this).addClass("active-d")
    }
    
  });
  
  
  if( $(".next-prev").length ) {
  	$(".next-prev .left a").html("< Previous");
    $(".next-prev .right a").html("Next >");
  }
  
  
  $(".site-nav--active").closest(".site-nav--has-dropdown").addClass("active-d");
   
  
  //about section equalize height;
//    $('#about-section').equalize('height'); 
//    $('#about-equalize').equalize('height'); 

  $( window ).resize(function() {
    console.log("jey");
//     $('#about-section').equalize('height'); 
//     $('#about-equalize').equalize('height'); 
  });

  
  
  $('#product').on('init', function(event, slick){
     var $items = slick.$dots.find('li');
     $items.addClass('transparent-circle');
     $items.find('button').remove();
  });

 var product_slick =  $("#product")
 
 product_slick.slick( {
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 6000,
    speed: 300,
    slidesToShow: 1,
  });
  
  product_slick.on('afterChange', function(event, slick, currentSlide, nextSlide){
    variant = $(slick.$slides.get(currentSlide)).attr('data-variant');
    if(variant != "")
    $("#ProductSelect").val(variant);
    
  });
  
  
  
   $("#ProductSelect").change(function(e){
        e.preventDefault();
     	
		product_slick.slick('slickGoTo', parseInt( $(this).find(":selected").attr("data-index")) );
    });
  
  
  
  
});